// src/GiftInfo.js

import React from 'react';
import './GiftInfo.css';

const GiftInfo = () => {
  return (
    <section className="gift-note">
      <p>
        Your presence is the only present we need. Having you there to bounce and
        celebrate with Advait is the best gift of all.
      </p>
    </section>
  );
};

export default GiftInfo;
